<template>
	<c-modal @close="close" :title="'Serienummers (Bulk)'">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<c-textarea
				:label="'Serienummers (komma gescheiden)'"
				:horizontal="true"
				placeholder="12345678, 12345678, 1234578, etc"
				v-model="bulkItems"
				rows="12"
				style="height:auto;"
				/>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button 
						class="margin-t-32 margin-b-16 no-margin-b" 
						type="submit"
						:disabled="!bulkItems">
							Toevoegen
					</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';

export default {
	mixins: [Form],
	components: {
		CModal,
	},
	data() {
		return {
			bulkItems: ''
		};
	},
	props: {
		product: {
			required: false
		}
	},
	watch: {},
	methods: {
		close() {
			this.$emit('close');
		},
		submit() {
			this.$emit('added', this.bulkItems.split(','), this.product);
			this.close();
			this.bulkItems = '';
		}
	}
}
</script>
